"use client"

import { Breadcrumb, BreadcrumbProps } from "antd";
import Link from "@/components/common/LinkNext";

const TEBreadcrumb = (props: any) => {
  const itemRender: BreadcrumbProps["itemRender"] = (
    currentRoute,
    _,
    items
  ) => {
    const isLast = currentRoute?.path === items[items.length - 1]?.path;

    return isLast ? (
      <span>{currentRoute.title}</span>
    ) : (
      <Link href={currentRoute.path as string}>{currentRoute.title}</Link>
    );
  };

  return <Breadcrumb {...props} separator={"|"} itemRender={itemRender} />;
};

export default TEBreadcrumb;
